import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', '1492818302069438');
    w.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-112">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1492818302069438&ev=PageView&noscript=1" alt="" data-id="element-113" />
    </noscript>;
}